import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Grey rows in a table's place while its rows load.
const TableSkeleton = ({ rows = 8, columns = 6 }) => (
  <div className="border border-mediumgray rounded-xl bg-white overflow-hidden">
    {Array.from({ length: rows }).map((_, r) => (
      <div
        key={r}
        className="flex items-center gap-4 px-5 py-4 border-b border-lightgray"
      >
        {Array.from({ length: columns }).map((_, c) => (
          <div key={c} className="flex-1">
            <Skeleton height={16} />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default TableSkeleton;
